import { render, staticRenderFns } from "./notiValidateModal.vue?vue&type=template&id=0632c56c&scoped=true"
import script from "./notiValidateModal.vue?vue&type=script&lang=js"
export * from "./notiValidateModal.vue?vue&type=script&lang=js"
import style0 from "./notiValidateModal.vue?vue&type=style&index=0&id=0632c56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632c56c",
  null
  
)

export default component.exports